import { expressionScope } from '../../../constants/expressions'

const dynamicExpressionPropsGetters = [...expressionScope]
const fieldDynamicExpressionProps = [...expressionScope, 'field', 'fieldGroup', 'fieldSet']

export { dynamicExpressionPropsGetters, fieldDynamicExpressionProps }
